type ContractOption = { id: string; description?: string | null };

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isSameContractId = (contractId: string, value: string) =>
  contractId.toLowerCase() === value.toLowerCase();

export const findContractById = <TContract extends ContractOption>(
  contracts: readonly TContract[] | null | undefined,
  value: string,
) => contracts?.find((contract) => isSameContractId(contract.id, value));

export const resolveContractName = (
  contracts: readonly ContractOption[] | null | undefined,
  value: string,
  contractNotFoundLabel?: string,
) => {
  const contract = findContractById(contracts, value);

  if (contract) return contract.description ?? value;
  if (contracts && contractNotFoundLabel && GUID_PATTERN.test(value)) return contractNotFoundLabel;

  return value;
};
